import PropTypes from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const configType = PropTypes.shape({
    EVA_LESS_THAN_10_SALARY_PERCENTAGE: PropTypes.number.isRequired,
    EVA_10_TO_20_SALARY_PERCENTAGE: PropTypes.number.isRequired,
    EVA_21_TO_30_SALARY_PERCENTAGE: PropTypes.number.isRequired,
    EVA_31_TO_40_SALARY_PERCENTAGE: PropTypes.number.isRequired,
    EVA_MORE_THAN_40_SALARY_PERCENTAGE: PropTypes.number.isRequired,
    TOLERANCE_NOT_OK_SALARY_PERCENTAGE: PropTypes.number.isRequired,
    TOLERANCE_OK_SALARY_PERCENTAGE: PropTypes.number.isRequired,
    WELDING_QUALITY_BAD_SALARY_PERCENTAGE: PropTypes.number.isRequired,
    WELDING_QUALITY_NEUTRAL_SALARY_PERCENTAGE: PropTypes.number.isRequired,
    WELDING_QUALITY_GOOD_SALARY_PERCENTAGE: PropTypes.number.isRequired,
});



// WEBPACK FOOTER //
// ./src/propTypes/config.js